<script>
  import ScreenGroupsItem from './ScreenGroupsItem'

  export default {
    name: 'screen-groups-container',

    components: { ScreenGroupsItem },

    props: {
      groups: {
        type: Array,
        required: true
      }
    }
  }
</script>

<template>
  <b-row class="p-4">
    <screen-groups-item v-for="group in groups" :key="group.screenGroupId" :group="group"/>
  </b-row>
</template>
